import React, { useEffect } from "react";
import { Outlet, useNavigate, useSearchParams } from "react-router-dom";
import { useUnit } from "effector-react";
import { $userBasicInfo } from "@/features/user/store";
import { CommonModal } from "@/core/components/commonModal/CommonModal";
import { SvgIcon } from "@/core/components/svgIcon/SvgIcon";
import { setModalIsOpened } from "@/core/store/app";
import Loader from "@/core/components/loader/Loader";
import "./GoalsPage.scss";
import { SEO } from "@/core/components/SEO/SEO";

export const GoalsLayout: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const showUpgradeModal = searchParams.get("upgrade") === "true";

  const userBasicInfo = useUnit($userBasicInfo);
  const { pro_user } = userBasicInfo || {};
  const loading = userBasicInfo === null;

  const handleCloseUpgradeModal = () => {
    setSearchParams({}, { replace: true });
    setModalIsOpened(false);
  };

  const handleViewPlans = () => {
    navigate("/settings/subscription");
  };

  if (loading) {
    return <Loader message="Loading..." />;
  }

  if (pro_user === false) {
    return (
      <>
        <SEO title={`Funding Goals | EUcalls`} description={`Funding Goals`} />
        <div className="goals-page--locked">
          <div className="goals-page--locked__content">
            <div className="goals-page--locked__icon-wrapper">
              <div className="goals-page--locked__rings">
                <div className="ring ring--1"></div>
                <div className="ring ring--2"></div>
                <div className="ring ring--3"></div>
              </div>
              <div className="goals-page--locked__icon">
                <SvgIcon icon="icon-starter-plan" />
              </div>
            </div>
            <h2 className="goals-page--locked__title">No goals created yet</h2>
            <p className="goals-page--locked__text">
              Set a new goal to view matching calls.
            </p>
            <button
              onClick={() => {
                setSearchParams({ upgrade: "true" });
                setModalIsOpened(true);
              }}
              className="goals-page--locked__button"
            >
              <SvgIcon icon="icon-add" />
              Create new goal
              <span className="pro-badge">Pro</span>
            </button>
          </div>
        </div>

        <CommonModal
          onClose={handleCloseUpgradeModal}
          hasForm={false}
          width={430}
          height={500}
          icon="icon-lighting"
          isOpen={showUpgradeModal}
          actions={
            <div className="form-actions">
              <button
                type="button"
                className="btn-secondary"
                onClick={handleCloseUpgradeModal}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn-primary"
                onClick={handleViewPlans}
              >
                View plans
              </button>
            </div>
          }
        >
          <div className="proModal">
            <div className="proModal-title">
              Get full access to Pro features with a paid plan
            </div>
            <div className="proModal-description flex flex-col gap-1">
              You could do so much more with our Professional and Premium plans.
              Unlock features like:
              <div className="proModal-list">
                <div className="flex gap-05">
                  <SvgIcon icon="icon-check" /> Advanced funding goal tracking
                </div>
                <div className="flex gap-05">
                  <SvgIcon icon="icon-check" />
                  Personalized call matching
                </div>
                <div className="flex gap-05">
                  <SvgIcon icon="icon-check" />
                  Goal analytics and insights
                </div>
              </div>
            </div>
          </div>
        </CommonModal>
      </>
    );
  }

  return (
    <div className="goals-page">
      <Outlet />
    </div>
  );
};
